const Arrow: React.FC<Partial<{ className: string; fill: string }>> = ({
  className,
  fill,
}) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M9.21743 1.06334C8.93686 0.786071 8.48458 0.788771 8.20729 1.06938C7.93008 1.34999 7.93272 1.80224 8.21336 2.07951L13.4821 7.28572H0.856864C0.462378 7.28572 0.142578 7.6055 0.142578 8C0.142578 8.3945 0.462378 8.71429 0.856864 8.71429H13.4804L8.21336 13.9189C7.93272 14.1961 7.93008 14.6484 8.20729 14.929C8.48458 15.2096 8.93686 15.2123 9.21743 14.9351L15.5939 8.63429C15.9476 8.28479 15.9476 7.71364 15.5939 7.36407L9.21743 1.06334Z"
        fill={fill || "#CAC2C3"}
      />
    </svg>
  );
};

export default Arrow;
